import _ from "lodash";

export const entity = {
    name: "Stakeholder",
    fields: [
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {

                const translate = context?.translateName || (w => w)

                return callback(null, object.name && translate(object.name))
            }
        },
        "StakeholderType",
        {
            path: "fullName",
            fieldPath: ['stakeholderType.translatedName', 'translatedName'],
            $f: function (object, context, callback) {
                const translate = context?.tc || (w => w)
                return callback(null, `${object.stakeholderType?.translatedName}${translate('colon_separator')}${object.translatedName}`)
            }
        }
    ],
    filters: [
        {
            name: "byStakeholderType",
            path: "stakeholderType",
            object: "StakeholderType",
            display: "name",
            translateName: true,
            clearable: true,
            client: true,
            isDefault: false,
            query: function (context) {
                const stakeholderTypeId = _.get(context.data, "stakeholderType.id")
                return stakeholderTypeId ? {stakeholderType: new global.ObjectID(stakeholderTypeId)} : {}
            }
        },
        {
            name: "excludeSelectedTypes",
            isDefault: false,
            query: function(context) {
                const selectedStakeHolders = _.get(context, 'data.stakeHolders') || []

                const selectedIds = selectedStakeHolders.map(sh => new global.ObjectID(sh.id))

                const usedTypeIds = selectedStakeHolders
                    .filter(sh => sh.stakeholderType)
                    .map(sh => new global.ObjectID(sh.stakeholderType.id))

                return usedTypeIds.length > 0 ?
                    {
                        $or: [
                            { stakeholderType: { $nin: usedTypeIds } }, // exclude used types
                            { _id: { $in: selectedIds } }               // but keep selected ones
                        ]
                    }
                    : {}
            }
        }
    ]
}

export const module_ = {
    object: "Stakeholder",
    tKey: "mTitle_stakeholder",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            {path: "stakeholderType", display: "codeName"},
            "code",
            {path: "name", translateName: true},
        ],
        form: [
            {path: "stakeholderType", display: "codeName"},
            {path: "code"},
            {path: "name", type: "textarea"}
        ]
    },
    filters: ["byStakeholderType"]
}
